import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["height", "margin", "width"];
import styled from 'styled-components';
import { KOALA, BATTLESHIP } from 'HubStyleTokens/colors';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterProps } from 'foundations-components/utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
const remCalc = size => {
  return `${Number(size)}px`;
};
const LoadingSkeletonLegacy = styled.div.attrs({
  'data-loading': 'true'
})(({
  height,
  width
}) => `
      @keyframes pulse {
        from {
          background-color: ${KOALA};
        }
        to {
          background-color: ${BATTLESHIP};
        }
      }
      &&& {
        background-color: ${KOALA};
        border-radius: 4px;
        height: ${!!height && remCalc(`${height}`)};
        width: ${`${width}`.endsWith('%') ? width : remCalc(`${width}`)};
        animation: 2s ease-in-out 0s infinite alternate both running pulse;
      }

      @media (prefers-reduced-motion) {
        animation: none;
      }
    `);
const TransitionalLoadingSkeleton = styled(LoadingSkeletonLegacy)(({
  $cssStyles
}) => Object.assign({}, $cssStyles));
export const LoadingSkeleton = _ref => {
  let {
      height,
      margin,
      width
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const legacyProps = {
    height,
    margin,
    width
  };
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(TransitionalLoadingSkeleton, Object.assign({}, legacyProps, domProps, {
    $cssStyles: cssStyles
  }));
};
export default LoadingSkeleton;